import React from 'react';
import { useHistory } from 'react-router-dom';
import connectUser from '../connectUser';
import AppTile from '../ui/AppTile';
import HiveButton from '../ui/HiveButton';
import Icon from '../ui/Icon';
import { installedStandaloneApps, installedPersonalApps, installedApps } from '../registry/selectors';
import './screens.css';

function MyAppsScreen({ userInfo }) {
  const history = useHistory();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const standalone = installedStandaloneApps(routes);
  const personal = installedPersonalApps(routes);
  const total = installedApps(routes).length;

  return (
    <div className="hive-container hive-screen">
      <h1 className="hive-h2 hive-screen-h">My Apps</h1>

      {total === 0 ? (
        <div className="hive-empty hive-empty-lg">
          <div className="hive-empty-ic"><Icon name="Layers" size={30} /></div>
          <p className="hive-empty-title">No apps yet</p>
          <p>Browse the store to find apps for your business.</p>
          <HiveButton variant="gold" onClick={() => history.push('/store')}>Explore Apps</HiveButton>
        </div>
      ) : (
        <>
          {standalone.length > 0 && (
            <section className="hive-screen-section">
              <h2 className="hive-section-title hive-store-heading">Apps</h2>
              <div className="hive-tile-grid">
                {standalone.map((app) => (
                  <AppTile key={app.id} app={app} state="open" onClick={() => history.push(app.path)} />
                ))}
              </div>
            </section>
          )}

          {personal.length > 0 && (
            <section className="hive-screen-section">
              <h2 className="hive-section-title hive-store-heading">Personal</h2>
              <p className="hive-subtle">Features enabled just for your account.</p>
              <div className="hive-tile-grid">
                {personal.map((app) => (
                  <AppTile key={app.id} app={app} state="open" onClick={() => history.push(app.path)} />
                ))}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
}

export default connectUser(MyAppsScreen);
